//
// Module for Calculation Results step content (partial view) displayed within Retirement Benefit Setup wizard
//
rs.module("participant/benefit/setup/retirement/wizard/calculationresultsstepcontent",

    ["controls/navigation/wizard"],

    function (wizard) {

        // Initialize the module
        function initialize(jsSelectors, backendUrls) {

            // get JS selectors
            var stepContentContainer = $.js(jsSelectors.stepContentContainer);
            var recalculateButton = stepContentContainer.js(jsSelectors.recalculateButton);
            var loadingSpinner = stepContentContainer.js(jsSelectors.loadingSpinner);

            // Get the wizard's next and back buttons for enabling/disabling 
            var wizardNextButton = $(`[data-wizard]`).js("_next");
            var wizardBackButton = $(`[data-wizard]`).js("_back");

            // Get the form (this will be the wizard form)
            var _form = stepContentContainer.closest("form");

            // Reset validation
            $.validator.resetValidation(_form);

            // recalculateButton click handler
            recalculateButton.on("click", function (event) {

                // prevent the button from causing a post
                event.preventDefault();

                if (_form.valid()) {

                    // disable buttons
                    recalculateButton.setDisabled();
                    wizardNextButton.setDisabled();
                    wizardBackButton.setDisabled();

                    loadingSpinner.show();

                    $.post(
                        {
                            url: backendUrls.recalculateResults,
                            headers: wizard.getNavigationToken(),
                            data: new FormData(_form[0]),
                            contentType: false,
                            cache: false,
                            processData: false
                        }
                    ).done(function (html, status, xhr) {

                        // Populate the parent container with the returned partial view
                        stepContentContainer.parent().html(html);

                    }).always(function (html, status, xhr) {

                        // Re-enable buttons
                        recalculateButton.setDisabled(false);
                        wizardNextButton.setDisabled(false);
                        wizardBackButton.setDisabled(false);

                        loadingSpinner.hide();
                    });
                }
            });
        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);